<template>
  <el-dialog
    v-if="visible"
    :visible="visible"
    :title="title || $l('dialog_title_putShelves_sku') || '上架SKU'"
    show-close
    top="10vh"
    width="95%"
    :close-on-click-modal="false"
    :before-close="() => $refs.main.cancel()"
    v-el-dialog-drag
    :modal-append-to-body="false"
    :modal="false"
  >
    <Main ref="main" @reload="$emit('reload')" @close="close()" />
    <span slot="footer">
      <el-button size="small" @click="$refs.main.cancel()">
        {{ this.$l('INDEX.btn_cancel') || '取消' }}
      </el-button>
      <el-button type="primary" size="small" @click="$refs.main.putShelves()">
        {{ $l('btn_putShelves') || '上架' }}
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
